import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { environment } from "src/environments/environment";
import { HelpModel } from "common/models/page-models/help/help-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";

@Injectable({
    providedIn: 'root'
})
export class HelpFormDataService extends FormDataService<HelpModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.help, http, ss);
    }

    createInstance(): HelpModel {
        return new HelpModel();
    }
    
  

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.helpGet,
            method: API_METHODS.post
        }
        return edit;
    }

    override modifyAPIResponse(response: any) {
        const dataModel = this.createInstance();
        dataModel.content = response?.details?.content;
        return dataModel;
    }
}
